import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../../store';
import './paramTable';


@customElement('page-tables-second')
export class PageTablesSecond extends connect(store)(LitElement) {

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	render() {
		return html`
		<specsheet-light-section>
			<page-header content-title="${msg('Example days')}" label-choice="profile"></page-header>
			<div slot="content">
				<param-table fixed-date="2024-06-15T00:00:00"></param-table>
				<param-table fixed-date="2024-09-15T00:00:00"></param-table>
			</div>
			<page-footer></page-footer>
		</specsheet-light-section>
		`;
	}
}
